import ShDividerLine from '@/components/Helpers/ShDividerLine';
import ShButton from '@/components/Helpers/ShButton';
import EmptyListOnStartup from '@/components/Common/EmptyListOnStartup';
import NumberListItem from './NumbersListItem';
import HintAndExplanation from '@/components/Common/HintAndExplanation';

// @vue/component
export default {
  name: 'NumbersList',

  components: {
    ShButton,
    NumberListItem,
    EmptyListOnStartup,
    ShDividerLine,
    HintAndExplanation,
  },

  data() {
    return {
      number: null,
      isValid: false,
      validationErrorMessage: null,
      errorMessageTimer: null,
    };
  },

  computed: {
    possibleNumberOfNumbersAccordingToAccessPermissionsDefinitions() {
      return this.$store.getters['authorization/accessPermissionsDefinitions'].global_options.number_of_numbers;
    },
    isWaitingForNumbersList() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'numbers/getList',
        'numbers/create',
        'numbers/delete',
      ]);
    },
    numbersList() {
      return this.$store.getters['numbers/list'];
    },
    listOfNumberNotVerified() {
      return this.numbersList.filter(number => !number.is_verified);
    },
    listOfNumbersThatCanBeAssigned() {
      return this.numbersList.filter(number => number.is_verified && !number.assigned_to_agent_id);
    },
    listOfNumberThatAreAssigned() {
      return this.numbersList.filter(number => !!number.assigned_to_agent_id);
    },
    isEmpty() {
      return this.numbersList.length === 0;
    },
  },

  created() {
    this.$store.dispatch('numbers/getList');
  },

  methods: {
    async handleAddNewNumber() {
      if (!this.isValid) {
        this.__showErrorMessage('Numer musi mieć dokładnie 9 cyfr');
        return;
      }
      const newNumber = await this.$store.dispatch('numbers/create', this.number);
      this.$EventBus.$emit('NumbersListItem/VERIFY_NUMBER', newNumber);
      await this.$store.dispatch('numbers/getList');
      this.$notify.success({
        title: 'Dodanie nowego numeru',
        message: `Dodano numer: ${this.number}`,
        customClass: 'callmeweb-notification',
      });

      this.number = null;
    },
    validateNumberLength() {
      this.isValid = false;
      this.__hideErrorMessage();

      if (/[^0-9]/i.test(this.number)) {
        this.isValid = false;
        this.__showErrorMessage('Proszę wpisać prawidłowy numer');
      }

      if (this.number.length > 9) {
        this.isValid = false;
        this.__showErrorMessage('Numer musi mieć dokładnie 9 cyfr');
      }

      if (this.number.length === 9) {
        this.isValid = true;
      }
    },
    __showErrorMessage(message) {
      this.validationErrorMessage = message;
      if (this.errorMessageTimer !== null) {
        clearTimeout(this.errorMessageTimer);
        this.errorMessageTimer = null;
      }

      this.errorMessageTimer = setTimeout(() => {
        this.validationErrorMessage = null;
      }, 1000);
    },
    __hideErrorMessage() {
      this.validationErrorMessage = null;
      if (this.errorMessageTimer !== null) {
        clearTimeout(this.errorMessageTimer);
        this.errorMessageTimer = null;
      }
    },
  },
};
